<template>
  <div class="shadow rounded-2xl flex flex-col bg-transparent">
    <!-- Top: image + title -->
    <div
      class="relative w-full bg-gray-200 overflow-hidden"
      :class="showSpecsSummary ? 'rounded-t-2xl' : 'rounded-t-2xl rounded-b-2xl'"
      style="height: 220px;"
    >
      <!-- Skeleton loader while image is loading -->
      <div
        v-if="!isImageLoaded"
        class="absolute inset-0 w-full h-full bg-gray-300 animate-pulse"
        style="object-position: center; transition: opacity 0.3s;"
      ></div>
      <img
        :src="resolvedImage"
        alt="Casting"
        class="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
        style="object-position: center;"
        :style="{ opacity: isImageLoaded ? 1 : 0 }"
        @load="isImageLoaded = true"
      />
      <div class="relative z-10 p-4 pb-0 h-full flex items-start">
        <div
          class="text-white font-bold text-2xl text-left leading-tight drop-shadow"
          :class="textClass"
          style="word-break: auto-phrase; max-width: 55%; text-align: left; font-family: 'Comfortaa';"
        >{{ title }}</div>
      </div>
      <span
        v-if="badgeInfo.label"
        :class="[
          'absolute right-0 bottom-0 px-3 py-1 text-sm font-semibold shadow-lg select-none',
          badgeInfo.textColor,
          badgeInfo.bgColor
        ]"
        style="z-index: 30; border-radius: 10px 0 0 0; margin: 0;"
      >
        {{ badgeInfo.label }}
      </span>
      <span
        v-if="castingId"
        class="absolute left-0 bottom-0 px-3 py-2 text-xs text-white"
        style="z-index: 30; margin: 0 0 0 0.25rem;"
      >
        COD. {{ castingId }}
      </span>
    </div>
    <!-- Specs summary card (desktop only) -->
    <div
      v-if="showSpecsSummary"
      class="hidden md:flex flex-col bg-white rounded-b-2xl px-5 py-4 border-t border-gray-100"
      style="font-size: 15px;"
    >
      <div class="flex flex-row justify-between items-center mb-1">
        <div class="font-semibold text-gray-900 text-left">Compenso</div>
        <div class="font-bold text-gray-900 text-lg text-right">{{ pay }}</div>
      </div>
      <div class="flex flex-row justify-between items-center mb-1">
        <div class="text-gray-500 text-left">Date</div>
        <div class="text-gray-700 text-right">{{ date }}</div>
      </div>
      <div class="flex flex-row justify-between items-center">
        <div class="text-gray-500 text-left">Luogo</div>
        <div class="text-gray-700 text-right">{{ place }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CuCastingThumb",
  props: {
    image: { type: String, required: true },
    title: { type: String, required: true },
    textClass: { type: String, default: '' },
    subscriptionStatus: { type: Number, default: -1 },
    showSpecsSummary: { type: Boolean, default: false },
    pay: { type: String, default: '' },
    date: { type: String, default: '' },
    place: { type: String, default: '' },
    castingId: { type: [String, Number], default: null },
  },
  data() {
    return {
      isImageLoaded: false
    }
  },
  computed: {
    resolvedImage() {
      // If image is a relative path, use require to resolve it
      if (this.image && this.image.startsWith('@/')) {
        try {
          return require(`${this.image.replace('@/', '../')}`)
        } catch (e) {
          return this.image
        }
      }
      return this.image
    },
    badgeInfo() {
      // Map status to label and colors
      const status = this.subscriptionStatus
      switch (status) {
        case 0:
        case 1:
          return {
            label: "CANDIDATO",
            textColor: "text-white",
            bgColor: "bg-primary"
          }
        case 2:
          return {
            label: "CONFERMATO",
            textColor: "text-white",
            bgColor: "bg-green-400"
          }
        case 3:
          return {
            label: "NON SELEZIONATO",
            textColor: "text-white",
            bgColor: "bg-red-500"
          }
        case 5:
          return {
            label: "CASTING CHIUSO",
            textColor: "text-black",
            bgColor: "bg-yellow-300"
          }
        case 6:
          return {
            label: "OPZIONATO",
            textColor: "text-black",
            bgColor: "bg-yellow-300"
          }
        case 4:
        case -1:
        default:
          return {
            label: "",
            textColor: "text-transparent",
            bgColor: "bg-transparent"
          }
      }
    }
  }
}
</script>
